import React from "react";
import { Typography, Box } from "@mui/material";
import RenderHTML from "components/RenderHTML";

const ContentDetails = ({ details, content }) => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        {content.title}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {content.description}
      </Typography>
      {details.map((detail, detailIndex) => (
        <Box key={detailIndex} sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {detail.title}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            <RenderHTML htmlContent={detail.content} />
          </Typography>
        </Box>
      ))}
    </>
  );
};

export default ContentDetails;
